const animation = require('../utils/animation');
const calculate = require('../utils/calculate');

const actionCart = 'Cart-RemoveProductLineItem';
const actionAddProduct = 'Cart-AddProduct';

const progress = {
  build: (progressTotal, maxValue, container) => {
    const $container = container || $('.product-detail');
    const locale = $container.data('locale');
    const $shippingContainer = $container.find('.free-shipping-container');
    const $shippingDeafultText = $('.default-text');
    const $shippingMissingAmout = $('.shipping-missing-text');
    const valueShipping = $shippingContainer.find('.value-shipping').data('value');
    const $shippingResultItem = $shippingContainer.find('.shipping-result-text');
    const thresholdMsg = $shippingContainer.attr('data-threshold-msg');
    const $progressElement = $('.progress-value');
    const animationLength = 10;
    const localeAttribute = locale && locale.replace('_', '-');
    const currencyAttribute = $shippingContainer.data('currency');

    let result = progressTotal;
    if (progressTotal < 0 || progressTotal > 100) {
      result = 100;
    }

    // displaying text by threshold
    if (progressTotal >= parseFloat(thresholdMsg) && result < 100) {
      const resultText = valueShipping - maxValue;
      $('.value-shipping-result').html(resultText.toLocaleString(localeAttribute, { style: 'currency', currency: currencyAttribute }));
      $shippingDeafultText.addClass('d-none');
      $shippingMissingAmout.removeClass('d-none');
      $shippingResultItem.addClass('d-none');
    } else if (result >= 100) {
      $shippingDeafultText.addClass('d-none');
      $shippingMissingAmout.addClass('d-none');
      $shippingResultItem.removeClass('d-none');
    } else {
      $shippingMissingAmout.addClass('d-none');
      $shippingDeafultText.removeClass('d-none');
      $shippingResultItem.addClass('d-none');
    }

    $('.shipping-text-container').removeClass('d-none');

    // progress bar
    if (result > 0) {
      animation.default.progress($progressElement, result, animationLength);
      $progressElement.addClass('is-active');
    }
  },
  handlerUpdateProgress($container) {
    $(document).ajaxComplete(function (e, xhr) {
      let existAction;

      if (xhr.responseJSON) {
        existAction = true;
      } else {
        existAction = false;
      }

      if (xhr.status === 200 && existAction) {
        const httpRequestResponse = xhr.responseText.trim() !== '' ? JSON.parse(xhr.responseText.toString()) : '';

        if (httpRequestResponse.action === actionCart || httpRequestResponse.action === actionAddProduct) {
          const $miniCart = $('.minicart .minicart-subtotal');
          const $shippingContainer = $('.free-shipping-container');
          const valueShipping = $shippingContainer.find('.value-shipping').data('value');

          const formatValueSubTotal = parseFloat($miniCart.attr('value').replace('€', '').replace(',', '.').trim());
          const subTotals = calculate.default.progress(formatValueSubTotal, valueShipping);
          const progressFreeShipping = formatValueSubTotal;

          progress.build(subTotals, isNaN(progressFreeShipping) ? valueShipping : progressFreeShipping, $container);
        }
      }
    });
  }
};

export default progress;
